// extracted by mini-css-extract-plugin
export default {"wrapper":"montaje-module--wrapper--feT-z","price_header":"montaje-module--price_header--pefCr","price_text":"montaje-module--price_text--79RiD"};